
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#400F3F","rx":"16"}}),_c('path',{attrs:{"fill":"#FF4702","fill-rule":"nonzero","d":"M54.72 57.8l13.356-23.128C66.116 34.252 64.1 34 62 34c-6.72 0-12.88 2.38-17.696 6.3l10.248 17.78.168-.28zm33.992-4.2c-2.576-8.176-8.82-14.728-16.8-17.752L61.664 53.6h27.048zm.728 2.8H68.468l.812 1.4 13.328 23.1C87.2 75.916 90 69.308 90 62c0-1.932-.196-3.78-.56-5.6zM52.312 62l-10.92-18.9C36.828 48.084 34 54.692 34 62c0 1.932.196 3.78.56 5.6h20.972l-3.22-5.6zm-17.024 8.4c2.576 8.176 8.82 14.728 16.8 17.752L62.336 70.4H35.288zm31.556 0l-10.92 18.928c1.96.42 3.976.672 6.076.672 6.72 0 12.88-2.38 17.696-6.3L69.448 65.92l-2.604 4.48z"}})])])
          )
        }
      }
    